// Fonte de verdade do status da licenca na visao do cliente. O banco nao muda o
// status quando o periodo acaba (uma assinatura vencida continua 'active'), e
// is_valid e a revogacao manual — a mesma regra que a Edge Function aplica antes
// de emitir o token do plugin. Concentrar isso aqui evita o que confundia antes:
// o card mostrava "Expirada" em verde e o "Status da Conta" ficava fixo em
// "Ativa", contradizendo um ao outro.
//
// Retorna { texto, cor, fundo } com classes Tailwind, pronto para o badge do
// SubscriptionCard e para o "Status da Licenca" do UserInfo.
export function estadoLicenca(subscription) {
  if (!subscription) {
    return { texto: 'Sem assinatura', cor: 'text-gray-600', fundo: 'bg-gray-100' };
  }

  const fim = subscription.current_period_end
    ? new Date(subscription.current_period_end)
    : null;
  const vencida = fim ? fim <= new Date() : false;

  if (subscription.is_valid === false) {
    return { texto: 'Revogada', cor: 'text-red-600', fundo: 'bg-red-100' };
  }
  if (vencida) {
    return { texto: 'Expirada', cor: 'text-red-600', fundo: 'bg-red-100' };
  }

  switch (subscription.status) {
    case 'active':
      return { texto: 'Ativa', cor: 'text-green-600', fundo: 'bg-green-100' };
    case 'past_due':
      return { texto: 'Pagamento pendente', cor: 'text-yellow-700', fundo: 'bg-yellow-100' };
    case 'canceled':
      return { texto: 'Cancelada', cor: 'text-red-600', fundo: 'bg-red-100' };
    case 'incomplete':
      return { texto: 'Aguardando pagamento', cor: 'text-gray-600', fundo: 'bg-gray-100' };
    default:
      return { texto: subscription.status ?? 'Desconhecido', cor: 'text-gray-600', fundo: 'bg-gray-100' };
  }
}

// Dias até current_period_end (negativo/zero se já venceu). null sem data.
// Centralizado aqui porque SubscriptionCard, DashboardPage e DownloadsPage
// reimplementavam essa mesma conta cada um do seu jeito.
export function diasRestantes(subscription) {
  if (!subscription?.current_period_end) return null;
  const fim = new Date(subscription.current_period_end);
  return Math.ceil((fim - new Date()) / 86400000);
}

export function assinaturaVencida(subscription) {
  const dias = diasRestantes(subscription);
  return dias !== null && dias <= 0;
}

// Regra de liberação de download do plugin — mesma regra que a Edge Function
// check-plugin-access aplica antes de emitir o token: status active, is_valid
// e período ainda não vencido. DashboardPage e DownloadsPage usavam queries
// diferentes pra decidir isso (uma aceitava past_due, a outra não), e podiam
// discordar sobre a mesma assinatura ao mesmo tempo. Buscar sempre a mesma
// linha (status active/past_due) e decidir aqui evita essa divergência.
export function podeBaixarPlugin(subscription) {
  return (
    subscription?.status === 'active' &&
    subscription?.is_valid === true &&
    !assinaturaVencida(subscription)
  );
}
